import React from 'react';
import PropTypes from 'prop-types';
import { ToggleBackground, Indicator } from './FormModeToggleStyles';

const FORM_MODES_TYPES = {
  DRAFT: 'draft',
  PUBLISHED: 'published'
};

const FormModeToggle = (props) => {
  const { displayedFormMode, changeDisplayedMode } = props;

  const togglePublishState = () => {
    const newValue = displayedFormMode === FORM_MODES_TYPES.DRAFT ?
      FORM_MODES_TYPES.PUBLISHED : FORM_MODES_TYPES.DRAFT;
    changeDisplayedMode(newValue);
  };

  return (
    <ToggleBackground
      role="radiogroup"
      aria-orientation="horizontal"
      data-aut="toggleMode"
    >
      <button
        type="button"
        role="radio"
        aria-checked={displayedFormMode === FORM_MODES_TYPES.DRAFT}
        className={displayedFormMode === FORM_MODES_TYPES.DRAFT && 'active'}
        onClick={displayedFormMode === FORM_MODES_TYPES.PUBLISHED && togglePublishState}
      >
        <span>Draft</span>
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={displayedFormMode === FORM_MODES_TYPES.PUBLISHED}
        className={displayedFormMode === FORM_MODES_TYPES.PUBLISHED && 'active'}
        onClick={displayedFormMode === FORM_MODES_TYPES.DRAFT && togglePublishState}
      >
        <span>Published</span>
      </button>
      <Indicator
        activeIsPublished={displayedFormMode === FORM_MODES_TYPES.PUBLISHED}
      ></Indicator>
    </ToggleBackground>
  );
};

FormModeToggle.propTypes = {
  displayedFormMode: PropTypes.oneOf([
    FORM_MODES_TYPES.DRAFT,
    FORM_MODES_TYPES.PUBLISHED,
  ]),
  changeDisplayedMode: PropTypes.func,
}

export default FormModeToggle;